import React from 'react';

const FilterPanel = ({ filters, onChange, darkMode }) => {
  const handleChange = (key, value) => {
    onChange({ [key]: value });
  };

  return (
    <div className={`filter-panel ${darkMode ? 'dark-mode' : ''}`}>
      <div className="filter-group">
        <label>Start Date</label>
        <input
          type="date"
          value={filters.startDate ? new Date(filters.startDate).toISOString().split('T')[0] : ''}
          onChange={(e) => handleChange('startDate', e.target.value ? new Date(e.target.value) : null)}
        />
      </div>
      <div className="filter-group">
        <label>End Date</label>
        <input
          type="date"
          value={filters.endDate ? new Date(filters.endDate).toISOString().split('T')[0] : ''}
          onChange={(e) => handleChange('endDate', e.target.value ? new Date(e.target.value) : null)}
        />
      </div>
      <div className="filter-group">
        <label>Email</label>
        <input
          type="text"
          value={filters.email || ''}
          onChange={(e) => handleChange('email', e.target.value)}
          placeholder="Filter by email"
        />
      </div>
      <div className="filter-group">
        <label>IP Address</label>
        <input
          type="text"
          value={filters.ipAddress || ''}
          onChange={(e) => handleChange('ipAddress', e.target.value)}
          placeholder="Filter by IP"
        />
      </div>
      <div className="filter-group">
        <label>Page Size</label>
        <select
          value={filters.pageSize || 50}
          onChange={(e) => handleChange('pageSize', parseInt(e.target.value))}
        >
          <option value={50}>50</option>
          <option value={100}>100</option>
          <option value={500}>500</option>
        </select>
      </div>
    </div>
  );
};

export default FilterPanel;

